import React, { useState, useRef, useEffect } from "react";
import "../../css/ReleaseNotes.css";
import { BiTrendingUp } from "react-icons/bi";
import AOS from "aos";
import "aos/dist/aos.css";
import { BsStars } from "react-icons/bs";
import { CgDebug } from "react-icons/cg";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";

export default function ReleaseNotes() {
  const [openIndex, setOpenIndex] = useState(null);
  const cardRefs = useRef([]);
  const scrollPositionRef = useRef(0);
  const importAll = (r) => {
    const map = {};
    r.keys().forEach((key) => {
      map[key.replace("./", "")] = r(key);
    });
    return map;
  };

  const images = importAll(
    require.context(
      "../../../assets/changelog",
      false,
      /\.(png|jpe?g|svg|webp)$/,
    ),
  );

  const releases = [
     {
  version: "Version 17",

  description: [
    "Version 17 introduces new AI-powered capabilities (Beta) in FrothTestOps to simplify access to platform information and accelerate automation script development.",
  ],

  details: [
    {
      title: "FrothAI Chatbot — Beta",
      heading: "Features",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Introduced the FrothAI chatbot for querying FrothTestOps platform, module, and project information.</li>
          <li>Provides quick access to relevant information without requiring users to navigate through multiple modules.</li>
        </ul>`,
      ],
      image: "version-17.1-1.png",
    },

    {
      title: "AI Playwright Script Generation — Beta",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Added AI-powered Playwright script generation to the Automation Script feature.</li>
          <li>Enables users to generate browser automation scripts faster with reduced manual effort.</li>
          <li>Improves consistency and supports faster script development and maintenance.</li>
        </ul>`,
      ],
      image: "version-17.1-2.png",
    },
  ],
},
    {
  version: "Version 16",

  description: [
    "This release introduces significant enhancements to Automation, Security Testing, AI, Performance Testing, Reporting, and Requirement Management. This release focuses on simplifying test execution, improving visibility, strengthening security, and providing a more intuitive user experience across the FrothTestOps platform.",
  ],

  details: [
    {
      title: "Performance Test Lab",
      heading: "Features",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `
        <li style="list-style-type: none;">Our browser extension is now available for Google Chrome and Microsoft Edge, enabling users to easily record both Automation Scripts and Performance (HAR) recordings from a single recording interface. This simplifies test creation and reduces manual effort.</li>
        `,
      ],
      image: "version-16.1-1.png",
    },

    {
      title: "Security Test Lab",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Security Testing has been significantly improved with better scan management, simplified report generation, and improved visibility into security scan results. Users can quickly review scan history, monitor vulnerabilities, and generate reports for better decision-making  </li>
          <li>Introduced the Schedule Scan feature, allowing users to automate and plan security scans at specific times, frequencies, and time zones for continuous vulnerability monitoring.</li>
        </ul>`,
      ],
      image: "version-16.1-2.png",
    },

    {
      title: "Test Lab",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `
          <li style="list-style-type: none;">Introduced Script Recorder to automatically capture user workflow activities and generate automation scripts, eliminating the need for manual script creation. </li>
`,
      ],
      image: "version-16.1-3.png",
    },

    {
      title: "Help",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<li style="list-style-type: none;">
          Introduced a centralized Help hub providing quick access to the official website, comprehensive user guides, change logs, and a self-service support portal. </li>
        `,
      ],
    },

    {
      title: "Task Management",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<li style="list-style-type: none;">
Introduced the Task Management module, enabling users to create and manage tasks associated with assigned requirements, test cases, or defects. Users can update task statuses to effectively track progress throughout the task lifecycle.         `,
      ],
      image: "version-16.1-5.png",
    },

    {
      title: "AI Evaluation",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `
          <li style="list-style-type: none;">Introduced the AI Evaluation Module to enable comprehensive assessment of AI-powered conversational systems through automated testing, execution, and reporting. The module includes Conversational Evaluation for validating AI responses against predefined test scenarios, Live Chat Evaluation for assessing real-time chatbot interactions, and a centralized Reports dashboard for monitoring evaluation results, performance metrics, and execution history </li>
        `,
      ],
      image: "version-16.1-6.png",
    },

    {
      title: "Code Analyzer",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `
          <li style="list-style-type: none;">The Code Analyzer module enables users to integrate source code repositories and initiate Static Application Security Testing (SAST) and Secret Scanning to identify security vulnerabilities, code quality issues, and exposed secrets. It provides comprehensive scan reports with actionable insights, helping to detect and remediate security risks early in the software development lifecycle. </li>
        `,
      ],
      image: "version-16.1-7.png",
    },

    {
      title: "FrothAI",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
       `
          <li style="list-style-type: none;">Introduced the FrothAI feature to accelerate the software testing lifecycle through AI-assisted artifact generation. FrothAI enables users to automatically generate Requirements, Test Scenarios, and Test Cases from user inputs using intelligent AI processing. The feature supports category-based generation, provides AI confidence scoring, generates multiple test artifacts in a structured format, and maintains traceability between requirements, test scenarios, and test cases. </li>
        `,
      ],
      image: "version-16.1-8.png",
    },
  ],
},
    {
  version: "Version 15",

  description: [
    "This release introduces Azure DevOps integration capabilities along with key improvements to test execution usability and cross-system traceability, enabling teams to manage quality processes more efficiently across platforms.",
  ],

  details: [
    {
      title: "Azure DevOps Integration",
      heading: "Features",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>You can now configure integrations with Azure DevOps directly from the Integrations settings, allowing seamless connectivity between TestOps and external development workflows.</li>
        </ul>`,
      ],
      image: "version-15.1-1.png",
    },

    {
      title: "Requirements Synchronization",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `
        <li style="list-style-type: none;">Bi-directional synchronization of requirements between TestOps and Azure DevOps is now supported.</li>
        <ul style="list-style-type: disc;">
          <li>Ensures real-time alignment across systems.</li>
          <li>Maintains a complete audit trail for all changes.</li>
          <li>Improves end-to-end traceability.</li>
        </ul>`,
      ],
      image: "version-15.1-2.png",
    },

    {
      title: "Defect Synchronization",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `
        <li style="list-style-type: none;">Defect data can now be synchronized between TestOps and Azure DevOps with full audit tracking.</li>
        <ul style="list-style-type: disc;">
          <li>Enhances visibility of defect lifecycle</li>
          <li>Maintains consistency across tools</li>
          <li>Supports better collaboration between QA and development teams</li>
        </ul>`,
      ],
      image: "version-15.1-3.png",
    },

    {
      title: "Test Lab – Automation Execution",
      heading: "Enhancement",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `
        <li style="list-style-type: none;">The Automation Execution interface within Test Cycles has been enhanced for improved usability.</li>
        <ul style="list-style-type: disc;">
          <li>Cleaner and more intuitive UI</li>
          <li>Better execution visibility</li>
          <li>Streamlined user experience during test runs</li>
        </ul>`,
      ],
      image: "version-15.2-1.png",
    },
  ],
    },
    {
  version: "Version 14",

  description: [
    "This release introduces a review workflow for manual test executions, improving validation, control, and auditability of test results.",
  ],

 details: [
  {
    title: "Test Cycle – Review Workflow",
    buttonClass: "btn btn-success btn-sm me-2",
    icon: "",
    text: [
      `<ul style="list-style-type: disc;">
        <li>Introduced a Review Actions workflow for executed test cases in Manual Test Cycles.</li>
      </ul>`,
    ],
    image: "version-14.1-1.png",
  },
  {
    image: "version-14.1-2.png",
  },
  {
    icon: "",
    text: [
      `<ul style="list-style-type: disc;">
        <li>Users can now submit completed test cases for review, enabling approval actions with comments.</li>
      </ul>`,
    ],
    image: "version-14.2-1.png",
  },
  {
    
    image: "version-14.2-2.png",
  },
  {
    buttonClass: "btn btn-success btn-sm me-2",
    icon: "",
    text: [
      `<ul style="list-style-type: disc;">
        <li>Ensuring manual test execution results are formally validated, auditable, and controlled without altering the original execution outcome.</li>
      </ul>`,
    ],
    image: "version-14.3-1.png",
  },
 
],
    },
    {
  version: "Version 13",

  description: [
    "This release introduces Discussions for improved collaboration, along with enhancements to Security Test Lab scan monitoring, BrowserStack log management, Scheduler audit visibility, and a Search & Replace feature in the Script Editor to improve efficiency and traceability across the platform.",
  ],

  details: [
    {
      title: "Discussions",
      heading: "Features",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Introduced Discussion Comment Sections across all modules where comment functionality exists.</li>
          <li>Comments now support user attribution and expandable views, enabling better collaboration, traceability, and clearer communication between team members.</li>
        </ul>`,
      ],
      image: "version-13.1-1.png",
    },

    {
      title: "Security Test Lab",
      heading: "Enhancement",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Implemented API-based scan execution status monitoring and automated report retrieval within the Scan section.</li>
          <li>This improves integration with security scanning tools and ensures scan results are automatically captured and accessible.</li>
        </ul>`,
      ],
      image: "version-13.2-1.png",
    },

    {
      title: "BrowserStack Integration",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Added the ability to download BrowserStack execution reports, allowing users to retrieve and store reports for long-term retention and troubleshooting.</li>
        </ul>`,
      ],
      image: "version-13.2-2.png",
    },

    {
      title: "Scheduler Enhancements",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Enhanced scheduler management by implementing Global Audit History visibility within the Dashboard, providing better traceability of scheduler changes.</li>
          <li>Test Cycle options are now disabled during scheduler editing to prevent unintended modifications.</li>
        </ul>`,
      ],
      image: "version-13.2-3.png",
    },

    {
      title: "Automation Script & Performance Test Lab",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Added a Search and Replace feature within the Script Editor, allowing users to quickly locate and update script content, improving efficiency when modifying large automation or performance scripts.</li>
        </ul>`,
      ],
      image: "version-13.2-4.png",
    },
  ],
    },
    {
  version: "Version 12",

  description: [
    "This release introduces AI-powered test case generation from defects, along with improvements to requirement management and navigation across testing artifacts.",
  ],

  details: [
    {
      title: "AI-Powered Test Case Generation",
      heading: "Features",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Introduced an AI feature to generate test cases from defects using Steps to Reproduce, enabling faster creation of relevant test cases directly from defect details.</li>
        </ul>`,
      ],
      image: "version-12.1-1.png",
    },

    {
      title: "Parent Requirement Management",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Enhanced the Requirements section to display and manage child tickets within the Requirement View/Edit page, improving visibility and traceability.</li>
        </ul>`,
      ],
      image: "version-12.1-2.png",
    },

    {
      title: "Requirements",
      heading: "Enhancement",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Added Module and Build fields during AI-generated Test Scenario and Test Case creation, ensuring better project mapping and organization.</li>
        </ul>`,
      ],
    },

    {
      title: "Navigation Improvements",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Enabled clickable links for Requirement, Test Scenario, and Test Case IDs, allowing users to quickly navigate to their respective view pages.</li>
        </ul>`,
      ],
    },

    {
      title: "Settings – Roles",
      buttonClass: "btn btn-success btn-sm me-2",
      icon: "",
      text: [
        `<ul style="list-style-type: disc;">
          <li>Added Audit History in the Roles Dashboard page, enabling better visibility and traceability of role-related changes.</li>
        </ul>`,
      ],
      image: "version-12.2-3.png",
    },
  ],
    },
    {
      version: "Version 11.2",
      description: [
        "This release introduces HAR-based performance script recording while strengthening reporting, expanding AI-driven test generation, and improving administrative visibility.",
      ],
      details: [
        {
          title: "Performance Testing",
          heading: "Features",
          buttonClass: "btn btn-success btn-sm me-2",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">
          <li >Introduced HAR-based performance script recording, enabling controlled Start and Stop of recording sessions.</li></ul>`,
          ],
          image: "version-11.2-1.1.png",
        },
        {
          title: "AI Test Automation",
          buttonClass: "btn btn-success btn-sm me-2",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; "> 
          <li>Enabled contextual AI test scenario generation by displaying requirement descriptions during scenario creation to improve accuracy and coverage.</li>
         </ul>`,
          ],
          image: "version-11.2-1.2.png",
        },
        {
          title: "Administrative Visibility",
          buttonClass: "btn btn-success btn-sm me-2",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">         
           <li>Added Recent User Login monitoring in the Global Dashboard for enhanced access visibility.</li>
           <li>Introduced Role Distribution Overview to support user management.</li>
         </ul>`,
          ],
          image: "version-11.2-1.3.png",
        },
        {
          title: "User Activity Monitoring",
          buttonClass: "btn btn-success btn-sm me-2",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">         
           <li>Implemented User Login History and Audit History, providing traceability of user actions and access events.</li>
         </ul>`,
          ],
          image: "version-11.2-1.4.png",
        },
        {
          title: "Performance Test Lab",
          heading: "Enhancement",
          buttonClass: "btn btn-success btn-sm me-2",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">
          <li>Enabled export of performance execution data from the Execute Script Dashboard.</li>
          </ul>`,
          ],
          image: "version-11.2-2.1.png",
        },
        {
          title: "AI Capabilities",
          buttonClass: "btn btn-success btn-sm me-2",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">
          <li>Enhanced AI test scenario generation to support unlimited prompt input.</li>
          </ul>`,
          ],
        },
        {
          title: "Reporting",
          buttonClass: "btn btn-success btn-sm me-2",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">
          <li>Enhanced the Requirement Traceability Report to include Custom Fields, improving reporting completeness and audit readiness.</li>
          </ul>`,
          ],
          image: "version-11.2-2.3.png",
        },
        {
          title: "Security Test Lab",
          buttonClass: "btn btn-success btn-sm me-2",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">
          <li>Enabled export of scan results for improved analysis and compliance reporting.</li>
          <li>Enhanced deleted target management with a View All option for better recovery control.</li>
          </ul>`,
          ],
          image: "version-11.2-2.4.png",
        },
      ],
    },
    {
      version: "Version 11.1",
      description: [
        "This release brings focused AI enhancements, expanded Security Test Lab capabilities, and key usability improvements across Test Cycles, Requirements, and Settings. The update improves system monitoring, scan visibility, execution traceability, and configuration efficiency.",
      ],
      details: [
        {
          title: "OpenAI Token Expiry Monitoring & Notification System",
          heading: "AI Enhancements",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">
          <li>Implemented proactive monitoring for OpenAI token expiry.</li>
          <li>Added alert and notification mechanisms to prevent AI service disruptions.</li>
          <li>Enhanced AI infrastructure with token handling and vector DB implementation for improved stability and scalability.</li>
        </ul>`,
          ],
          image: "version-11.1-AI.png",
        },
        {
          title: "Manual Test Cycle Execution History",
          heading: "Features",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">         
          <li>Introduced a new Execution History tab in the Test Cycle Execution page.</li>
          <li>Provides visibility into execution timelines, updates, and historical actions for manual executions.</li>
        </ul>`,
          ],
          image: "version-11.1-Manual-Execution.png",
        },
        {
          title: "Security Test Lab",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: [
            `<h6><strong>Target</strong></h6>
        <ul style="list-style-type: disc; ">         
          <li>Added Filter and Export options in the Target View page.</li>
          <li>Enabled Scan Name as a clickable hyperlink for quicker navigation to scan details.</li>
        </ul>`,
          ],
          image: "version-11.1-target.png",
        },
        {
          text: [
            `<ul style="list-style-type: disc; ">         
          <li>Introduced a Recently Deleted Targets card in the left panel for easier tracking.</li>
        </ul>`,
          ],
          image: "version-11.1-target2.png",
        },
        {
          title: "Scan",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">
          <li>Added Rescan option in the Scan Dashboard table actions.</li>
          <li>Enhanced ZAP Scan Report Downloads.</li>
          <li>Added informational messages for dropdown options in the Quick Scan page to improve clarity.</li>
        </ul>`,
          ],
          image: "version-11.1-Scan.png",
        },
        {
          title: "Settings",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">
          <li>Implemented “Select All” option in Settings – User Management for faster bulk selection and configuration.</li>
        </ul>`,
          ],
          image: "version-11.1-Settings.png",
        },
        {
          title: "Requirements",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">
          <li>Introduced “Requirement Status” as a new Tag Type.</li>
          <li>Enabled consistent status selection across the Requirement module, improving tracking and reporting.</li>
        </ul>`,
          ],
          image: "version-11.1-Requirement.png",
        },
      ],
    },
    {
      version: "Version 11",
      description: [
        "This release introduces the Performance Test Lab as a major new feature, along with multiple enhancements across Security Test Lab, Test Management, and platform usability.",
      ],
      details: [
        {
          title: "Performance Test Lab",
          heading: "Features",
          text: [
            `<ul>
          Introduced a comprehensive Performance Test Lab module with end-to-end support for performance testing workflows:
        </ul>`,
          ],
        },
        {
          text: [
            `<h6><strong>Dashboard</strong></h6>
        <ul>
          <li>Centralized dashboard providing visibility into executions, test data, and performance metrics.</li>
          <li>Supports export of performance data for reporting and analysis.</li>
          <li>Provides quick actions to create new performance scripts and configure load tests directly from the dashboard.</li>
        </ul>`,
          ],
          image: "version-11-dashboard.png",
        },
        {
          text: [
            `<h5><strong>Script Management</strong></h5>
        <ul>
          <li>Create new performance scripts via HAR file upload.</li>
          <li>View detailed script information using the dedicated View option.</li>
          <li>Script listing dashboard for easy access, organization, and management of performance scripts.</li>
        </ul>`,
          ],
          image: "version-11-script.png",
        },
        {
          text: [
            `<h5><strong>Load Testing</strong></h5>
        <ul>
          <li>Support for Simple and Advanced Load Tests.</li>
          <li>Flexible configuration options for different performance scenarios.</li>
        </ul>`,
          ],
          image: "version-11-load.png",
        },
        {
          text: [
            `<h5><strong>Execution</strong></h5>
        <ul>
          <li>Execute performance scripts with detailed execution view.</li>
          <li>Track execution progress and results through a unified interface.</li>
        </ul>`,
          ],
          image: "version-11-execution.png",
        },
        {
          text: [
            `<h5><strong>Reports</strong></h5>
        <ul>
          <li>Performance reports listing and detailed report view pages</li>
          <li>Clear visibility into execution metrics and results</li>
        </ul>`,
          ],
          image: "version-11-Reports.png",
        },
        {
          title: "Security Test Lab",
          heading: "Enhancement",
          text: [
                       `
        <strong class="ms-3">Added Audit History in:</strong>
         <ul>
          <li>Target Section → Target View page</li>
          <li>Scan Section → Scan Details View page</li>
          <p>Improved traceability of actions and changes for better compliance and auditing.</p>
        </ul>`,
          ],
          image: "version-11-Security.png",
        },
        {
          title: "Custom Fields",
          text: [
            `
        <strong class="ms-3">Implemented Custom Fields for:</strong>
        <ul> 
          <li>Test Scenario </li>
          <li>Test Case</li>
          <p>Enhanced flexibility in managing and capturing additional test metadata.</p>
        </ul>`,
          ],
          image: "version-11-Custom-Fields.png",
        },
        {
          title: "Fixes & Improvements",
          text: [
            `<ul>
          <li>General performance optimizations across dashboards and execution views.</li>
          <li>Stability improvements for report rendering and data export.</li>
          <li>UI and validation enhancements for better user experience.</li>
        </ul>`,
          ],
        },
      ],
    },
    {
      version: "Version 10.1",
      description: [
        "This version introduces key improvements across exports, dashboards, builds, filters, and automation capabilities—enhancing usability, visibility, and customization throughout the platform.",
      ],
      details: [
        {
          title: "Improved Test Case Excel Export (Detail Steps Alignment)",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          The Excel export for Test Cases now delivers accurate and consistent alignment of all step details within the <strong>“Detail Steps”</strong> column, ensuring cleaner reporting and better readability.
        </ul>`,
          ],
        },
        {
          title: "Enhanced Filter Visibility Across All Modules",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Filters are now more accessible and easier to manage across the platform, improving navigation and helping users quickly locate relevant data.
        </ul>`,
          ],
          image: "version-10.1-filter.png",
        },
        {
          title: "Dashboard Enhancements (Global & Project Dashboards)",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Both Global and Project dashboards have been upgraded to provide clearer visual insights, improved widget consistency, and better overall usability.
        </ul>`,
          ],
          image: "version-10.1-dashboard.png",
        },
        {
          title: "Build Enhancements – Build Name Support",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="">
          <li>A new <strong>Build Name</strong> field has been introduced.</li>
          <li>Build dropdowns now display <strong>Build Name along with Build ID</strong> for better clarity during selection.</li>
        </ul>`,
          ],
          image: "version-10.1-buildname.png",
        },
        {
          title: "Custom Fields for Build & Module (Settings)",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Custom Fields can now be created and managed specifically for <strong>Builds</strong> and <strong>Modules</strong>, enabling more flexible data capture and project customization.
        </ul>`,
          ],
          image: "version-10.1-custom field.png",
        },
        {
          title: "Capability Generator Update – OS X Support for Web",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          The Capability Generator now includes <strong>OS X</strong> as a supported option for Web capabilities, expanding automation coverage and environment compatibility.
        </ul>`,
          ],
          image: "version-10.1-capability.png",
        },
      ],
    },
    {
      version: "Version 10",
      description: [
        "Our latest release introduces several powerful enhancements: a new Security Scanning module, a sleek global notification ribbon, upgraded Play button behavior for both manual and automated executions, expanded control within Test Automation, and smarter requirement-driven filtering in Test Cycles.",
      ],
      details: [
        {
          title: "Security Testing Module",
          heading: "Features",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          The Security Testing module provides end-to-end visibility into the security posture of user-defined targets. It enables users to monitor scans, analyze vulnerabilities, and take action through an intuitive and comprehensive dashboard.
          <ul style="list-style-type: disc; ">
            <li>
              <strong>Centralized Security Dashboard:</strong>
            Offers a consolidated view of all targets, active and completed scans, recent activity, and the latest scan results—allowing users to quickly understand their current security status.
            </li>
          </ul>
        </ul>`,
          ],
          image: "version-10-Dashboards.png",
        },

        {
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">
          <li>
            <strong>Target Management:</strong>
            Users can seamlessly add new targets (applications, domains, or endpoints) and initiate security scans on demand.
          </li>
        </ul>`,
          ],
          image: "version-10-Targets.png",
        },

        {
          icon: <BiTrendingUp />,
          text: [
            `<ul style="list-style-type: disc; ">
          <li>
            <strong>Security Scan & Analysis:</strong>
            Perform in-depth security scans on user targets and provides clear insights into vulnerabilities, including severity, risk type, alert name, affected components, and total occurrences.Users can also download detailed security reports for audit and compliance purposes.
          </li>
        </ul>`,
          ],
          image: "version-10-analysis.png",
        },

        {
          title: "Deployment Notification Ribbon (Global Scrolling Alerts Bar)",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Introduced a unified, scrolling notification bar displayed to all users, ensuring organization-wide visibility for announcements, deployments, downtime alerts, and important system messages.
        </ul>`,
          ],
          image: "version-10-Features.png",
        },

        {
          title: "Improved Play Button Behavior in Test Cycle Execution",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="">
          <li>Execution details are locked after <strong>Stop—Executed By, Start/End Time,</strong> and <strong>Duration</strong> cannot be changed.</li>
          <li>All further updates must be made via <strong>Submit</strong>, with each action logged in Audit History</li>
          <li>Multiple users may update, but <strong>Executed </strong>By always stays with the original executor</li>
        </ul>`,
          ],
        },

        {
          title: "Enhanced Agent Management in Test Automation",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          A new <strong>View</strong> option provides quick agent-level insights, and users can now remove inactive or unused agents directly from the Agent Creation Dashboard —improving visibility and control over automation infrastructure.
        </ul>`,
          ],
          image: "version-10-Test-Automation.png",
        },

        {
          title: "Requirement-Based Test Case Filtering in Test Cycle",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Added the ability to <strong>filter test cases by Requirement Title</strong> within the Test Cycle execution page,allowing teams to:
        </ul>
        <ul style="">
          <li>Quickly narrow down relevant test cases</li>
          <li>Validate coverage more efficiently</li>
          <li>Improve traceability and execution focus</li>
        </ul>`,
          ],
          image: "version-10-Requirement.png",
        },
      ],
    },
    {
      version: "Version 9",
      description: [
        "In this release, we are introducing major enhancements across scheduling, notifications, and file handling to make user experience more seamless and efficient.",
      ],
      details: [
        {
          title: "Scheduler Enhancements",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="">
          <li>Added Custom Scheduler Options for Script Execution, giving teams more control over when and how automated test runs are triggered.</li>
          <li>Implemented Status Reset for Existing Cycles before each scheduler execution to ensure clean and consistent test runs.</li>
        </ul>`,
          ],
          image: "ver9-scheduler.png",
        },

        {
          title: "Enhanced Notifications",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="">
          <li>Email Notification management is now available in Settings for improved control.Users can now manage categorized email notifications in the dashboard, enabling or disabling them based on preferences.</li>
          <li>Approval emails now include the Approver Name for clearer communication and traceability during approval workflows.</li>
        </ul>`,
          ],
          image: "ver9-notifications.png",
        },

        {
          title: "Multiple Attachments Support",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Introduced the ability to upload multiple attachments across Test Cycles, Defects, and Requirements modules, improving collaboration and documentation efficiency.
        </ul>`,
          ],
          image: "ver9-multi.png",
        },

        {
          title: "Execution Page Enhancements",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Added Mapping Capability and Test Data Details directly within the Execution page and Audit History, enabling better traceability and faster data access during test runs.
        </ul>`,
          ],
          image: "ver9-Execution.png",
        },
      ],
    },
    {
      version: "Version 8.3",
      description: [
        "In this release, we are bringing Custom Fields for Requirements, enhanced Notifications Management and Request Page Dashboard, improved safeguards for project sync operations, extended cross-browser support in Capability, and sorting fixes for better consistency across the application.",
      ],
      details: [
        {
          heading: "Features",
          icon: <BiTrendingUp />,
          title: "Custom Fields",
          text: [
            `<ul>
          <li>Introduced <strong>Custom Fields Management</strong> in Settings for the Requirement module, enabling more flexible and configurable data handling.</li>
        </ul>`,
          ],
          image: "v-8.3-custom field.png",
        },

        {
          heading: "Enhancement",
          title: "Notifications",
          text: [
            `<ul>
          <strong>Notifications Management & Request Page Dashboard</strong> improved for better visibility and usability.        
        </ul>`,
          ],
          image: "v-8.3-Notifications.png",
        },

        {
          title: "Integration Sync",
          text: [
            `<ul>
          Added safeguard to <strong>prevent parallel sync by multiple users</strong> in the same project, with notification alerts.   
        </ul>`,
          ],
        },

        {
          title: "Capability",
          text: [
            `<ul>
          Extended <strong>Browserstack Device Configurations</strong> to support <strong>Edge and Firefox browsers.</strong>
        </ul>`,
          ],
          image: "v-8.3-Browserstack.png",
        },

        {
          heading: "Bug Fixes",
          title: "Sort Functionality",
          text: [
            `<ul>
          Revamped and fixed the <strong>Sort functionality</strong> across the entire application for consistent behavior.
        </ul>`,
          ],
          image: "v-8.3-Sort functionalitys.png",
        },
      ],
    },
    {
      version: "Version 8.2",
      description: [
        "This release enhances integrations, reporting, and test management with improved audit tracking, better report accessibility and streamlined Test Cycle handling.",
      ],
      details: [
        {
          title: "Settings > Integrations",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="margin-left:15px;">
          <li>Added confirmation popup with mapped project details when deleting Jira/Plane integrations.</li>
          <li>Audit history tracking extended for integrations and mapped projects.</li>
        </ul>`,
          ],
          image: "version8.2-Integration.png",
        },

        {
          title: "Reports",
          text: [
            `<ul>
          Report downloads now include attachment links instead of file names for easier access.
        </ul>`,
          ],
          image: "version8.2-report.png",
        },

        {
          title: "TestLab",
          text: [
            `<ul>
          Improved Test Cycle selection in Test Plan create/edit and view pages.
        </ul>`,
          ],
          image: "version8.2-Test-Lab.png",
        },
      ],
    },
    {
      version: "Version 8.1",
      description: [
        "This release strengthens integration, defect management, and test execution workflows, while adding new options for requirements sync, search, and evidence handling. Together, these updates improve traceability, usability, and reporting across TestOps.",
      ],
      details: [
        {
          title: "Integration – Jira",
          heading: "Features",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          <li><strong>Requirement Synchronization with Plane</strong> – Seamless sync with full audit trail to keep requirements up to date and changes transparent.</li>
        </ul>`,
          ],
          image: "version8-media.png",
        },

        {
          title: "Test Cycles",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="margin-left:15px;">
          <li>Defect linking for automation scripts to improve traceability.</li>
          <li>New search & filter options for easier execution management.</li>
        </ul>`,
          ],
        },

        {
          title: "Defect Management",
          icon: <BiTrendingUp />,
          text: [
            `<ul style="margin-left:15px;">
          <li>Jira sync now includes detailed audit logging.</li>
          <li>Better synchronization of imported defects with requirements.</li>
        </ul>`,
          ],
        },

        {
          title: "TestLab",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Automatic reset on re-run for cleaner and consistent executions.
        </ul>`,
          ],
        },

        {
          title: "Media",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Maximize option for attachment previews (screenshots, logs, videos) in cycle and reports.
        </ul>`,
          ],
          image: "version8-requirement.png",
        },
      ],
    },
    {
      version: "Version 8",
      description: [
        "This release brings powerful new integrations and usability improvements, including expanded Jira and GitLab support, plus enhancements to Requirements, Test Cycles, and evidence management. Together, these updates help teams manage the entire testing lifecycle more efficiently.",
      ],
      details: [
        {
          title: "Integration – Jira",
          heading: "Features",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Enhanced Jira integration to support syncing both <strong>Requirements</strong> and <strong>Defects</strong>, enabling complete end-to-end traceability within TestOps.
        </ul>`,
          ],
          image: "version-8-jira.png",
        },

        {
          title: "GitLab Integration",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Added <strong>GitLab integration</strong> to manage and sync automation scripts seamlessly with TestOps.
        </ul>`,
          ],
          image: "version-8-gitlab.png",
        },

        {
          title: "Requirements Module",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Introduced a <strong>Status Dropdown</strong> in Requirement creation, allowing teams to track requirement progress more effectively.
        </ul>`,
          ],
          image: "version-Requirements-8.png",
        },

        {
          title: "Test Cycle & Attachments",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          <li>All execution evidence (screenshots, logs, videos) is now moved to <strong>OneDrive</strong> for improved security.</li>
          <li>Evidence files are private to your organization, with options to <strong>view, download, and maximize</strong> directly within TestOps.</li>
        </ul>`,
          ],
          image: "Test-Cycle-version-8.png",
        },

        {
          title: "Search & Filter",
          heading: "Bug Fixes",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Improved global <strong>search and filtering functionality</strong> for more accurate and faster results.
        </ul>`,
          ],
        },

        {
          title: "Integration – Plane",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          Fixed syncing issue for Defects, ensuring defect data reflects correctly in TestOps.
          Resolved issue with <strong>multiple user linking</strong> from Plane integration.
        </ul>`,
          ],
        },
      ],
    },
    {
      version: "Version 7",
      description:
        "Easily configure and manage custom defect fields tailored to your needs, and sync them with tools like JIRA. Continue working without waiting for sync completion — you’ll receive a notification once the process is finished.",
      details: [
        {
          title: "Custom Fields configuration in Settings",
          heading: "Features",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          <li>Now you can create and manage Custom Fields in Settings for defect managemnt module — and sync them to your favorite tools like JIRA.</li>
          <li>This Custom Fields configuration gives you the flexibility to tailor defect forms with additional Fields based on your project or team requirements.</li>
        </ul>`,
          ],
          image: "version-7.png",
        },

        {
          title: "Defect Sync Just Got Smoother — No Need to Wait!",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: "You can now continue working while your defects are syncing in the background. We’ll notify you once the sync is complete, so you can stay productive without waiting on the page.",
        },
      ],
    },
    {
      version: "Version 6",
      description:
        "Introducing new integrations and enhancements to make TestOps smarter and more connected. With Plane and GitLab syncing, improved Test Cycle automation, and easier Precondition linking, your QA workflows are now faster and more efficient.",
      details: [
        // {
        //   title: "Integrate with Plane & GitLab",
        //   heading: "Features",
        //   buttonClass: "btn-new-heading-green me-1",
        //   icon: <BiTrendingUp />,
        //   text: "Users can now connect their TestOps workspace with Plane to sync issues and tasks effortlessly for better traceability.",
        // },

        {
          title: "Integrate with Plane & GitLab",
          buttonClass: "btn-new-heading-green me-1",
          icon: <BiTrendingUp />,
          text: "Users can now connect their TestOps workspace with Plane or GitLab to sync issues, tasks, and repositories effortlessly. This integration enables better traceability, automated repository sync, pipeline triggers, and direct commit management — all from within TestOps.",
          image: "planeandgit.png",
        },

        // {
        //   title: "Smarter Test Cycle Management",
        //   heading: "Enhancement",
        //   buttonClass: "btn-new-heading-green me-1",
        //   icon: <BiTrendingUp />,
        //   text: [
        //     `<ul>
        //     <li>While creating or updating Test Cycles, users now get automatic validation of Start and End Dates.</li>
        //     <li>Test Cycles will now auto-close when the End Date is reached and all executions are completed — no manual intervention needed.</li>
        //   </ul>`
        //   ],
        //   image: "smarter-test-cycle.png",
        // },

        {
          title: "Easier Precondition Linking",
          buttonClass: "btn-new-heading-green me-1",
          icon: <BiTrendingUp />,
          text: "While editing or creating a Test Case, users can now select existing Test Cases as preconditions using a convenient dropdown menu — boosting reusability and speed.",
          image: "precondition-linking.png",
        },
      ],
    },
    {
      version: "Version 5.5",
      description:
        "Minor enhancements in the Test Automation module, including improved UI for App & Media Upload filters, fixes in audit history export, and ability to view automation script descriptions without GitHub redirection.",
      details: [
        {
          text: "",
          image: "version5.png",
        },
      ],
    },
    {
      version: "Version 5.4",
      description:
        "Experience enhanced efficiency across all modules with quick edit on view page and export capabilities on audit. Streamline test management with drag & drop, and get access to live automation results.",
      details: [
        {
          title: "Test Cycle",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: "Easily rearrange test cases or test suites using drag & drop during Test Cycle creation/edit.",
          image: "test-cycle.png",
        },
        {
          title: "View Page",
          icon: <BiTrendingUp />,
          text: "Edit records directly from the view page without navigating back and forth.",
          image: "quick-edit.png",
        },
        {
          title: "Project Audit History",
          icon: <BiTrendingUp />,
          text: "Audit history can now be exported whenever needed for tracking or compliance.",
          image: "project-audit.png",
        },
        {
          title: "Automation Execution",
          icon: <BiTrendingUp />,
          text: "Jump directly to the Live Execution URL from Workflow View. Also added 'Not Run' status and clickable hyperlinks for easy navigation.",
          image: "automation-execution.png",
        },
      ],
    },
    {
      version: "Version 5.3",
      description:
        "Enhanced reporting with multi-select filters, and expanded Audit History export.",
      details: [
        {
          title: "Audit History Export",
          heading: "Feature",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: "Export functionality added across all major modules for comprehensive activity tracking and archiving.",
          image: "ExportAuditTT.png",
        },
        {
          title: "Multi-Selection Filters in Reports",
          text: "Flexible report filtering with multi-select dropdowns for more granular insights.",
          image: "Flexiblereport.png",
        },
      ],
    },
    {
      version: "Version 5.2",
      description:
        "Update includes a new Stakeholder role with approval and sign-off rights, JS Script support in Test Lab, forced password change on first login, auto-fill for test cases, and a new “Once” option in the Scheduler.",
      details: [
        {
          title: "Stakeholder Role",
          heading: "Features",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: "A new Stakeholder role has been introduced, providing users with full visibility into projects, the ability to export reports, and the authority to approve and sign off on test cases and test plans.",
          image: "521.webp",
        },
        {
          title: "Auto-Fill Test Case Feature",
          text: "Enabled auto-fill functionality for test case fields upon entering the test case name, streamlining the creation process and reducing manual data entry.",
          image: "522.webp",
        },
        {
          title: "Mandatory Password Change",
          text: "Implemented a forced password change on first login to strengthen account security and comply with best practices for user authentication.",
        },
        {
          title: "JS Script in Automation Script",
          heading: "Enhancement",
          buttonClass: "btn-new-heading-green me-1",
          icon: <BiTrendingUp />,
          text: "We’ve introduced a new JS Script application type in the Test Lab for automated scripts. Now you can write, manage, and execute JavaScript-based automation scripts directly within the platform.",
        },
        {
          title: "Scheduler - New Option in Frequency",
          text: "Introduced a “Once” option in the frequency dropdown on the Scheduler page, allowing users to configure and execute non-recurring schedules efficiently.",
        },
      ],
    },
    {
      version: "Version 5.1",
      description:
        "This version adds a Workflow View button in Test Cycle View to quickly check execution status and results, along with Audit History across key modules for better tracking and change visibility.",
      details: [
        {
          title: "One-Click Workflow View for Test Cycles",
          heading: "Features",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: [
            `<ul class="list-disc pl-5">
           <span>We’ve introduced a Workflow View for your test cycles to streamline execution and monitoring.</span>
           <li>Trigger the entire test cycle execution with a single click.</li>
           <li>Visual overview of all test suites arranged in your defined order.</li>
           <li>Auto-notifications upon execution completion.</li>
           <li>Retry failed suites instantly and continue execution from failed steps (for independent suites).</li>
         </ul>`,
          ],
          image: "511.webp",
        },
        {
          title: "Comprehensive Audit History Across All Modules",
          text: "Now track all actions across modules with full visibility. See who made changes, what was changed, and when for Projects, Test Cases, Test Cycles, and more. Stay compliant, transparent, and in control.",
          image: "512.webp",
        },
      ],
    },
    {
      version: "Version 5",

      description:
        "Introduced comprehensive audit trails, advanced scheduling features, seamless defect synchronization, enriched API support, and major Test Lab usability upgrades.",

      details: [
        // {
        //   title: "Audit History",
        //   heading: "Features",
        //   icon: <BsStars />,
        //   buttonClass: "btn-new-heading-blue me-2",
        //   text: "Implemented audit logs across Projects, Test Management, Test Lab and Defect Management.",
        //   image: '/assets/images/scheduler.png',
        // },

        {
          title: "Scheduler",
          text: "The Scheduler feature facilitates the automated execution of test cycles by allowing users to configure and manage execution.",
          image: "Scheduler.png",
        },

        {
          title: "API Testing",
          text: "API Testing capabilities have been extended to support advanced HTTP methods PUT, PATCH and DELETE enhancing flexibility and coverage in test scenarios.",
          image: "APITestings.png",
        },

        {
          title: "Defect Management",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: "Enhanced with background synchronization and improved Jira issue detection to ensure smoother and more reliable defect tracking.",
          image: "DefectManagement.png",
        },

        {
          title: "Test Cycle",
          text: "The user interface has been enhanced with improved test suite organization, advanced filtering options, and flexible rearrangement capabilities to streamline test management.",
          image: "TestCyclev5.png",
        },
      ],
    },
    {
      version: "Version 4.1",
      description:
        "AI credit restrictions in TestOps, improved BrowserStack error messages, dynamic browser titles, better license visibility, new fields in Test Management and Defect Management, and live URL notifications in Test Lab.",
      details: [
        {
          title: "User Dashboard",
          text: "The dashboard now displays the number of available licenses on the user's page, enhancing visibility and license management.",
          image: "availableLicenses.png",
        },
        {
          title: "Integration",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: "Error messages during BrowserStack integration deletion now offer more detailed information for easier issue resolution.",
        },
        {
          title: "Notification Changes",
          text: "Improved BrowserStack integration error messages, added live URL notifications in Test Lab Automation Suite, and enhanced defect and test case bulk editing with new fields.",
        },
        {
          title: "Test Lab",
          text: "Automation Suite now sends live URL notifications to users during execution, enhancing real-time tracking.",
        },
        {
          title: "Defect Management",
          text: "Test Case and Priority fields have been added to the Defect Bulk Edit and Filter pages, streamlining defect management and updates.",
        },
        {
          title: "Test Management",
          text: "The Precondition field has been added to the Test Case Bulk Edit and Filter pages, enhancing test case management and planning.",
        },
        {
          title: "API Testing",
          text: "Random value generation has been added to support easier test data creation and automation.",
        },
      ],
    },
    {
      version: "Version 4.0",
      description:
        "The updates include API Tokens, Media Upload, a Capability Generator, new Automation Actions, and improved API Testing with Git integration. Upload App is now Upload Media.",
      details: [
        {
          title: "Personal API Token",
          heading: "Features",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: "Added in profile options for secure automation execution with an expiry date.",
          image: "PersonalAPIToken.png",
        },
        {
          title: "Media Upload in Test Automation",
          text: "Upload images, documents, videos, APKs, and IPAs based on device farm support. Shared within the same project.",
          image: "MediaUpload2.jpg",
        },
        {
          title: "Capability Generator",
          text: "Configure execution on specific devices/browsers within the device farm. Supports shared or separate credentials within an organization.",
          image: "CapabilityGenerator.png",
        },
        {
          title: "New Automation Actions",
          text: "New mobile actions include Swipe to Fit, Swipe with Coordinates, and Swipe Until Visibility, while web actions include Dismiss Alert, Accept Alert, and Double Click.",
          image: "AutomationActions.png",
        },
        {
          title: "Cycle Creation",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: "Introduced selecting capability, app, and media for automation.",
        },
        {
          title: "Cycle Execution",
          text: "Capabilities, apps, and media can be edited only on the execution page.",
        },
        {
          title: "API Testing",
          text: [
            `<ul>
          <li>Supports negative scenario execution.</li>
          <li>Allows executing the same API with different data.</li>
          <li>Added "Submit & Automate" to push to Git for automation in TestOps.</li>
        </ul>`,
          ],
        },
        {
          title: "Naming Convention Update",
          text: "Upload App renamed to Upload Media to support applications and various media files.",
        },
      ],
    },
    {
      version: "Version 3.4.2",
      description:
        "This update brings email link access, improved notifications for integrations, and bulk approval for test cases.",
      details: [
        {
          title: "Request Bulk Approval",
          heading: "Features",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: "The Request Notification page has been enhanced to support bulk approval or rejection of test cases, enabling users to review and provide comments efficiently.",
          image: "bulkapproval.png",
        },
        {
          title: "Cross-module",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          buttonClass: "btn-new-heading-green me-1",
          text: "The ability to open links for Test cases, Test plans, and Test cycles directly from emails has been introduced, allowing for seamless approval or rejection without extensive navigation.",
        },
        {
          title: "Integration",
          text: "Email notifications are now triggered when any token in the integrated tool has expired or when a URL has been updated by a team member.",
        },
      ],
    },
    {
      version: "Version 3.4.1",
      description:
        "New features include enhanced filtering, attachment previews, and seamless test case approval. Admin can manage licenses and ensure proper tool integration.",
      details: [
        {
          title: "Notification Request Page",
          heading: "Features",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: [
            `<ul>
          <li>Users can now apply filters on the notification page to refine their view.</li>
          <li>Notifications for approval or rejection now display mapped requirements linked to test cases.</li>
          <li>Users can directly approve or reject test cases and test plans from the notification page by clicking the hyperlink.</li>
        </ul>`,
          ],
          image: "apiTestingsss.png",
        },
        {
          title: "Settings",
          text: "Admin can activate or deactivate users based on license usage while maintaining a history log to track user activity.",
          image: "user.png",
        },
        {
          title: "Request Bulk Approval",
          heading: "Bug Fixes",
          icon: <CgDebug />,
          buttonClass: "btn-new-heading-red me-2",
          text: "Ensured validation of mandatory custom fields in integrated defect tracking systems to prevent incorrect configurations. Users will now receive notifications if proper mapping is missing when integrating with JIRA or other third-party defect management tools.",
        },
      ],
    },
    {
      version: "Version 3.4",
      description:
        "The latest updates include app inactivation alerts, enhanced token management in TestOps, and direct agent creation from the Test Cycle page for easier testing.",
      details: [
        {
          title:
            "Automatic Inactivation of Application Uploaded to Device Farm",
          heading: "Features",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: [
            `<ul>
          <li>Users will now receive a notification if an uploaded app is inactivated after 30 days, as per device farm guidelines.</li>
          <li>This helps prevent issues with triggering automation.</li>
          <li>Users can re-upload the application to avoid any consequences.</li>
        </ul>`,
          ],
        },
        {
          title: "Enhanced Integration with Token Management",
          text: [
            `<ul> 
          <li>The Integration section in the Settings module has been enhanced based on token management.</li>
          <li>Users can configure their own tokens to perform activities in TestOps and track actions based on responsible users.</li>
          <li>Token configuration is now available for all integration tools.</li>
        </ul>`,
          ],
        },
        {
          title: "Direct Agent Creation from Test Cycle Page",
          text: [
            `<ul>
          <li>Users can now create an agent directly from the Test Cycle page for local testing with device farms like BrowserStack.</li>
          <li>A shortcut link is available during cycle creation, eliminating the need to navigate to Test Lab > Test Automation > Agent Creation.</li>
        </ul>`,
          ],
          image: "testcycle.png",
        },
      ],
    },
    {
      version: "Version 3.3.1",
      description:
        "The updates feature a syntax validator and project filtering by created date.",
      details: [
        {
          title: "Enhanced Editor Validation",
          heading: "Features",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: "Introduced a built-in syntax validator in the editor to ensure error-free scripting and prevent potential issues.",
          image: "syntaxvalidator.png",
        },
        {
          title: "Advanced Project Filtering",
          text: "You can now filter projects based on the Created Date, making it easier to organize and locate projects efficiently.",
          image: "created_date_project.png",
        },
      ],
    },
    {
      version: "Version 3.3",
      description:
        "Enhancements include AI-generated Test Scenarios, GitHub Agent creation, and improved export options and email notifications.",
      details: [
        {
          title: "Generation of Test Scenarios & Test Cases with AI",
          heading: "Features",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: "Generate TS and TC from Requirement: The AI-based generation of Test Scenarios and Test Cases has been implemented to streamline test creation from requriements. This feature automates the generation process, improving efficiency and accuracy in test management.",
          image: "Generationof.png",
        },
        {
          title: "Creation of GitHub Agents from Test Cycle Page",
          text: "GitHub Agent Creation: GitHub Agents can now be created directly from the Test Cycle page, simplifying the integration process.",
          image: "GitHub.png",
        },
        {
          heading: "Bug Fixes",
          icon: <CgDebug />,
          buttonClass: "btn-new-heading-red me-2",
          text: [
            `<ul>
          <li>Removed PDF and DOC formats from the Export option and Generate Reports section.</li>
          <li>Email notifications now display the username instead of the first name for better clarity and to avoid confusion.</li>
          <li>Test data names on the test data page were resolved for improved visualization.</li>
        </ul>`,
          ],
        },
      ],
    },
    {
      version: "Version 3.2.4",
      description:
        "The release introduces enhancements across dashboard visibility, test case validations, bulk upload restrictions, form interactions, automation execution, UI improvements, and defect/request handling to ensure better control, accuracy, and user experience.",
      details: [
        {
          heading: "Bug Fixes",
          icon: <CgDebug />,
          buttonClass: "btn-new-heading-red me-2",
          text: "",
        },
        {
          title: "Dashboard & Navigation",
          text: [
            `<ul>
          <li>Shows "No Data Found" if no project assigned.</li>
          <li>After user removal, page doesn’t reload; project name remains in breadcrumbs.</li>
        </ul>`,
          ],
        },
        {
          title: "Test Case Management",
          text: [
            `<ul>
          <li>Test cases can be deleted even if linked to cycles (with warning popup).</li>
          <li>Approval requires filled Approval Form.</li>
          <li>Estimated Time blocks text input; mandatory fields can't be blank.</li>
        </ul>`,
          ],
        },
        {
          title: "Bulk Upload Restrictions",
          text: [
            `<ul>
          <li>No mapping between Test Scenario IDs and Requirement IDs.</li>
        </ul>`,
          ],
        },
        {
          title: "Attachments & Forms",
          text: [
            `<ul>
          <li>Attachments can be previewed before submission.</li>
          <li>Empty spaces not allowed in mandatory fields.</li>
        </ul>`,
          ],
        },
        {
          title: "Automation & Execution",
          text: [
            `<ul>
          <li>Only active apps shown during test cycle creation.</li>
          <li>Suite name limited to 100 characters.</li>
          <li>Test suite execution depends on BrowserStack availability.</li>
        </ul>`,
          ],
        },
        {
          title: "User Interface Enhancements",
          text: [
            `<ul>
          <li>Multi-select filters enabled.</li>
          <li>Username shown instead of first name in exports, reports, and mail.</li>
        </ul>`,
          ],
        },
        {
          title: "Requests & Defects",
          text: [
            `<ul>
          <li>Request page shows items pending approval.</li>
          <li>‘Steps to Reproduce’ and ‘Comments’ retain data after sync in defects.</li>
        </ul>`,
          ],
        },
      ],
    },
    {
      version: "Version 3.2.3",
      description:
        "Key updates include API script creation, filtering by application type, enhanced Test Plan reporting, restricted permissions, and improved security with encrypted passwords.",
      details: [
        {
          title: "API Testing",
          heading: "Features",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: [
            `<ul>
          <li>API Scripts: Introduced support for creating API scripts, ensuring seamless API response display upon execution.</li>
          <li>Define Variables: Enhanced the validation page with options to configure action mode, value, and data type for both request and response parameters, and seamlessly push them as a JS file to the specified GitHub repository.</li>
        </ul>`,
          ],
          image: "seamless.png",
        },
        {
          title: "Automation Suite",
          text: [
            `<ul>
          <li>Included API as an option in the Application Type dropdown, enabling script filtering based on the selected application type.</li>
          <li>Introduced a Platform column to ensure accurate platform details for each selected script.</li>
        </ul>`,
          ],
          image: "suite_api.png",
        },
        {
          title: "Test Cycle",
          text: "Included API as an option in the Application Type dropdown, enabling suite filtering based on the selected application type.",
          image: "cycle_api.png",
        },
        {
          title: "Test Plan",
          text: "Enhanced the download functionality in the Test Summary Report to include updated test plan details for better reporting.",
          image: "testplan_download.png",
        },
        {
          heading: "Bug Fixes",
          icon: <CgDebug />,
          buttonClass: "btn-new-heading-red me-2",
          text: [
            `<ul>
          <li>Restricted users from creating records via quick actions without the necessary permissions.</li>
          <li>Ensured filters persist when viewing specific records.</li>
          <li>Included validation to restrict users from mapping test scenarios with any requirements during bulk test case edits.</li>
          <li>Prevented the deletion of test cases mapped to a test cycle.</li>
          <li>Introduced an option to clone or copy test scenarios and test cases to enhance usability.</li>
          <li>Encrypted passwords during login to secure payload transmission.</li>
          <li>Included the super admin option in the project selection dropdown.</li>
          <li>Excluded approvers from being listed in the Request Approval From dropdown.</li>
          <li>Displayed project statuses based on their categories.</li>
          <li>Resolved alignment issues in downloaded test summary reports.</li>
          <li>Disabled email notifications for password changes for Active Directory (AD) users.</li>
        </ul>`,
          ],
        },
      ],
    },
    {
      version: "Version 3.2.2",
      description:
        "Improvements include Agent creation, enhanced Test Management, fixed OS tags, and resolved bugs in status editing and defect management.",
      details: [
        {
          title: "Test Lab",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: "Introduced Agent creation functionality with the ability to view Agent status on the Agent Creation page.",
        },
        {
          title: "Test Management",
          text: "Added pagination and search functionality to the pre-condition list for improved navigation and data filtering.",
        },
        {
          heading: "Bug Fixes",
          icon: <CgDebug />,
          buttonClass: "btn-new-heading-red me-2",
          text: [
            `<ul>
          <li>Settings: Fixed an issue where created OS type tags were not reflected in the dropdown values.</li>
          <li>Test Management: Resolved a bug that allowed users to change the status from 'New' to 'Pending Approval' in bulk edit without selecting the 'Pending Approval' status, and fixed an issue where pre-condition data was not displayed after deleting a pre-condition.</li>
          <li>Defect Management: Resolved an issue in the defect creation form where the status dropdown displayed incorrect options after a page refresh when linked to a defect management tool.</li>
          <li>Dashboard: Corrected the display of Planned Start and End dates in the "My Project" table on the global dashboard.</li>
        </ul>`,
          ],
        },
      ],
    },
    {
      version: "Version 3.2.1",
      description:
        "Updates include project creation validation, a Select All checkbox in reports, and corrected priority colors in the defect chart.",
      details: [
        {
          title: "Projects",
          heading: "Feature",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: "Validation for project creation, enforcing a 2–5 character limit for the Short Code.",
          image: "projectshortcode.png",
        },
        {
          title: "Reports",
          text: "Added a Select All checkbox in the extended search section to automatically select all individual checkboxes.",
          image: "selectall_reports.png",
        },
        {
          heading: "Bug Fixes",
          icon: <CgDebug />,
          buttonClass: "btn-new-heading-red me-2",
          text: "Corrected the duplicate colors for priority levels in the defect report chart on the dashboard.",
        },
      ],
    },
    {
      version: "Version 3.2",
      description:
        "Improvements include default permission checks, restricted integration deletion, fixed tag display, and UI enhancements.",
      details: [
        {
          title: "Projects",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          <li>Default permissions are now automatically checked for new roles.</li>
          <li>Restricted deletion of integrations when projects are mapped.</li>
          <li>Ensured tags created for projects display correctly in dropdowns.</li>
        </ul>`,
          ],
        },
        {
          heading: "Bug Fixes",
          icon: <CgDebug />,
          buttonClass: "btn-new-heading-red me-2",
          text: [
            `<ul>
          <li>Addressed various UI inconsistencies in the Test Plan Sign-Off page and the left sidebar.</li>
          <li>Updated the Global Dashboard UI by hiding the project selection dropdown.</li>
          <li>Resolved the issue of deleted projects still appearing in dropdowns after a page refresh.</li>
        </ul>`,
          ],
        },
      ],
    },
    {
      version: "Version 3.1",
      description:
        "New features include test plan approvals, enhanced dashboards, improved workflows, domain login, and user limit error handling.",
      details: [
        {
          title: "Test Lab",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          <li>Test Plan Sign-Off: Introduced comprehensive test plans detailing scope, milestones, and deliverables, along with execution details and a review process for stakeholder approvals.</li>
          <li>Request Approval in Test Plan: Users can now request stakeholder approvals for finalized test plans.</li>
        </ul>`,
          ],
        },
        {
          title: "Dashboard",
          text: [
            `<ul>
          <li>Enhanced dashboard with better visibility into project performance and test results.</li>
          <li>Improved data filters for quick access to key metrics.</li>
        </ul>`,
          ],
        },
        {
          heading: "Bug Fixes",
          icon: <CgDebug />,
          buttonClass: "btn-new-heading-red me-2",
          text: [
            `<ul>
          <li>Login Enhancement: Users can now log in to TestOps using their registered domain from the product page.</li>
          <li>User Creation & License Validation: The system now shows an error when the user limit is exceeded based on the procured license and subscription duration.</li>
        </ul>`,
          ],
        },
      ],
    },
    {
      version: "Version 3.0",
      description:
        "Improvements include a new app upload path, enhanced agent creation with OS instructions, and improved GitHub repository mapping.",
      details: [
        {
          title: "Test Lab",
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          <li>BrowserStack App Upload: Added a new navigation path for uploading apps from Test Lab.</li>
          <li>Agent Creation: Enhanced the agent creation page with OS-specific instructions to streamline test execution processes.</li>
        </ul>`,
          ],
        },
        {
          title: "Settings",
          text: "Validation for project creation now enforces a 2–5 character limit for the Short Code.",
        },
      ],
    },
    {
      version: "Version 2.0",
      description:
        "The system now includes defect reporting, test case reports, database validation, test data import, user profiles, custom tags, and JIRA integration.",
      details: [
        {
          heading: "Features",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: "Defect Reports: Introduced a module for generating and managing defect reports.",
          image: "reports.png",
        },
        {
          text: "Profile Management: Introduced a user profile section to view details and update passwords.",
          image: "profiledetails1.png",
        },
        {
          text: [
            `<ul>
          <li>Test Case Reports: Added functionality to create comprehensive test case reports for better analysis and tracking.</li>
          <li>Test Lab Database Integration: Enabled real-time querying and validation during automated testing.</li>
          <li>Query & Assert During Script Preparation: Added support for queries and assertions during script preparation to ensure successful test case execution.</li>
          <li>Test Data Import: Users can now import test data in .json format directly, eliminating manual data entry</li>
        </ul>`,
          ],
        },
        {
          heading: "Enhancement",
          icon: <BiTrendingUp />,
          text: [
            `<ul>
          <li>Custom Dropdown Values: Added a Tags feature in settings for managing custom dropdown values based on project requirements.</li>
          <li>JIRA & Plan Integration: Enabled two-way integration with JIRA and Plan for seamless defect tracking and management.</li>
        </ul>`,
          ],
        },
      ],
    },
    {
      version: "Version 1.0",
      description:
        "The update includes Plane integration, GitHub/BrowserStack config, JSON upload, quick actions, device selection, enhanced security, and email notifications.",
      details: [
        {
          heading: "Features",
          title: "Plane Integration for Defect Creation and Tracking",
          icon: <BsStars />,
          text: "Seamlessly create and track defects directly from TestOps with our new Plane integration. This feature ensures better defect management and streamlined communication within your testing process.",
          buttonClass: "btn-new-heading-blue me-2",
        },
        {
          heading: "GitHub Configuration in Settings",
          text: "Link your GitHub repositories to TestOps easily through the settings. This integration allows you to sync your codebase and test plans effortlessly, promoting a smoother workflow and continuous integration.",
        },
        {
          heading: "BrowserStack Configuration in Settings",
          text: "Integrate your BrowserStack account with TestOps to automate execution across different browsers and devices. This feature simplifies cross-browser testing and ensures your applications perform flawlessly on various platforms.",
        },
        {
          heading: "Test Data Preparation and Integration",
          text: "Upload your test data in JSON format and execute your tests with various data sets. This feature enhances the flexibility and accuracy of your testing by allowing you to prepare and integrate test data efficiently.",
        },
        {
          heading: "Quick Actions",
          text: "Navigate and perform tasks faster with our new quick actions feature. Create features, manage configurations, and execute tests with a single click, saving you valuable time and effort.",
          image: "quickactions.png",
        },
        {
          heading: "Enhancements",
          title: "Device Selection from Device Farm",
          buttonClass: "btn-new-heading-green me-1",
          icon: <BiTrendingUp />,
          text: "During cycle creation, you can now select devices from the device farm to execute tests on any device you need. This improvement provides more control and flexibility over your testing environment.",
        },
        {
          heading: "Login with Security Puzzle",
          text: "To enhance security, we have added a security puzzle to the login process. This added layer of protection ensures that your account remains secure and protected from unauthorized access.",
        },
        {
          heading: "Email Notifications",
          text: [
            `<ul>
          <li>A user is added to TestOps.</li>
          <li>A test case is assigned to a user.</li>
          <li>A user initiates a password reset.</li>
        </ul>`,
          ],
        },
      ],
    },
    {
      version: "Beta",
      description:
        "The Defect Management module tracks defects with JIRA integration, while the Test Lab automates test execution, including script management, cycle planning, and progress monitoring.",
      details: [
        {
          heading: "Features",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          title: "A defect management module",
          text: [
            `<ul>
          <li>Defect Reporting and Tracking: Introduced features for reporting and tracking defects efficiently.</li>
          <li>Severity and Priority Assignment: Enabled the assignment of severity and priority levels to defects.</li>
          <li>Integration with JIRA Tool: Integrated defect management with JIRA for streamlined tracking.</li>
        </ul>`,
          ],
          image: "defect.png",
        },
        {
          title:
            "Combine several sub-modules aimed at automating and managing test execution processes",
          text: [
            `<ul>
          <li>Automation Script: Management and execution of automated test scripts.</li>
          <li>Automation Suite: Grouping of automated test scripts for efficient execution.</li>
          <li>Test Cycle: Planning and execution of test cycles.</li>
          <li>Test Plan: Comprehensive planning for test cycles, including objectives, resources, and schedules.</li>
          <li>Test Cycle Execution: Real-time monitoring and reporting of test cycle progress.</li>
        </ul>`,
          ],
          image: "testlab.png",
        },
      ],
    },
    {
      version: "Alpha",
      description:
        "The Project Management module handles workflows and resources, while Test Management supports test planning and execution. Settings manage users, roles, and integrations.",
      details: [
        {
          heading: "Features",
          title:
            "A comprehensive module to streamline project workflows, and manage timelines, resources & deliverables",
          icon: <BsStars />,
          buttonClass: "btn-new-heading-blue me-2",
          text: [
            `<ul>
          <li>Project Creation and Configuration: Set up and configure projects for testing.</li>
          <li>Resource Allocation: Allocate necessary resources for project execution.</li>
          <li>Requirement Creation and Configuration: Create and configure requirements for the project.</li>
          <li>Module Creation and Configuration: Set up and configure testing modules.</li>
          <li>Build Creation and Configuration: Create and configure builds for testing.</li>
        </ul>`,
          ],
          image: "project.png",
        },
        {
          title:
            "Provides a suite for planning, designing, and executing test cases",
          text: [
            `<ul>
          <li>Test Scenario Creation and Management.</li>
          <li>Test Case Creation and Management.</li>
        </ul>`,
          ],
          image: "testmanagement.png",
        },
        {
          title:
            "Allows administrators to configure and customize the application to meet organizational needs",
          text: [
            `<ul>
          <li>User management.</li>
          <li>Role-based access control.</li>
          <li>System integration and configuration.</li>
        </ul>`,
          ],
        },
      ],
    },
  ];
  const toggleCard = (index) => {
    const isOpening = openIndex !== index;

    if (isOpening) {
      scrollPositionRef.current = window.pageYOffset;
      setOpenIndex(index);

      setTimeout(() => {
        const element = cardRefs.current[index];
        if (element) {
          const y = element.offsetTop - 80;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 100);
    } else {
      setOpenIndex(null);

      setTimeout(() => {
        window.scrollTo({
          top: scrollPositionRef.current,
          behavior: "smooth",
        });
      }, 100);
    }
  };
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);
  return (
    <div className="release-container">
      {releases.map((release, index) => (
        <div
          key={index}
          ref={(el) => (cardRefs.current[index] = el)}
          className="release-card"
          data-aos="fade-up"
        >
          <div className="release-header" onClick={() => toggleCard(index)}>
            <h2>{release.version}</h2>
          </div>

          <p className="release-desc">{release.description}</p>
          {openIndex !== index && (
            <div className="details-toggle" onClick={() => toggleCard(index)}>
              See full details <MdOutlineKeyboardArrowDown />
            </div>
          )}

          {openIndex === index && (
            <div className="release-details">
              {release.details.map((item, i) => (
                <div key={i} className="detail-item">
                  {item.heading && (
                    <div
                      className={`feature-badge ${
                        item.heading?.toLowerCase() === "enhancement"
                          ? "enhancement-badge"
                          : item.heading?.toLowerCase() === "bug fixes"
                            ? "bugfix-badge"
                            : "features-badge"
                      }`}
                    >
                      {item.heading}
                    </div>
                  )}
                  <h6 className="fw-bold">{item.title}</h6>
                  <p className="feature-detail-text">
                    {(Array.isArray(item.text) ? item.text : [item.text]).map(
                      (t, idx) => (
                        <div
                          key={idx}
                          dangerouslySetInnerHTML={{ __html: t }}
                        />
                      ),
                    )}
                  </p>

                  {item.image && images[item.image] && (
                    <img
                      src={images[item.image]}
                      alt={item.title}
                      className="release-img"
                    />
                  )}
                </div>
              ))}
              <div className="details-toggle" onClick={() => toggleCard(index)}>
                Hide full details <MdOutlineKeyboardArrowUp />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
